import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

export default function SobreNos() {
  useEffect(() => {
    document.title = 'Sobre Nós - ClubdoCupom.com';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Conheça o ClubdoCupom.com: plataforma de assinaturas para lojistas divulgarem cupons direto ao consumidor. Sem afiliados, sem intermediários.');
    return () => {
      document.title = 'ClubdoCupom.com - O Canal Oficial do Desconto Direto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-between">
          <Link to="/" className="text-xl sm:text-2xl font-black text-slate-900" data-testid="sobre-logo">
            ClubdoCupom<span className="text-amber-500">.com</span>
          </Link>
          <Link to="/" className="text-xs sm:text-sm text-slate-600 hover:text-slate-900 transition-colors font-medium" data-testid="sobre-back-link">
            Voltar ao inicio
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 mb-8" data-testid="sobre-title">Sobre Nós</h1>

          <div className="prose prose-slate prose-lg max-w-none">
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-testid="sobre-text-main">
              O ClubdoCupom.com é uma plataforma de tecnologia que conecta lojistas e consumidores de forma inteligente. Diferente de outros sites, não trabalhamos com links de afiliados. Nosso modelo é baseado em assinaturas para lojistas, permitindo que as marcas gerem e divulguem seus melhores cupons diretamente para você. Nossa missão é ser o canal oficial de descontos reais, sem intermediários.
            </p>

            <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200 mt-10">
              <h2 className="text-xl font-bold text-slate-900 mb-4">Como funciona</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <span className="bg-amber-500 text-white font-bold rounded-full w-8 h-8 flex items-center justify-center shrink-0 text-sm">1</span>
                  <p className="text-slate-700"><strong>Lojistas assinam</strong> a plataforma e criam cupons de desconto exclusivos.</p>
                </div>
                <div className="flex gap-4">
                  <span className="bg-amber-500 text-white font-bold rounded-full w-8 h-8 flex items-center justify-center shrink-0 text-sm">2</span>
                  <p className="text-slate-700"><strong>Consumidores acessam</strong> os cupons gratuitamente e resgatam na loja.</p>
                </div>
                <div className="flex gap-4">
                  <span className="bg-amber-500 text-white font-bold rounded-full w-8 h-8 flex items-center justify-center shrink-0 text-sm">3</span>
                  <p className="text-slate-700"><strong>Economia direta</strong>: sem comissoes, sem afiliados, sem custos ocultos.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
